import {isOrderWithSample} from '@app/checkout/models/order-request.model';
import {ISampleType} from '@app/checkout/models/sample-type.model';
import {selectSampleTypes} from '@app/checkout/state/checkout.selector';
import {IMyOrderState} from '@app/order/models/my-order-state.model';
import {OrderUtils} from '@app/order/utils/order.utils';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';

export const selectMyOrderState = createFeatureSelector<IMyOrderState>(EState.MyOrders);
export const selectOrderDetails = createSelector(
  selectMyOrderState,
  (myOrdersState: IMyOrderState) => myOrdersState?.myOrderDetails
);

export const selectOrderDetailsStatus = createSelector(
  selectMyOrderState,
  (myOrdersState: IMyOrderState) => myOrdersState?.myOrderDetailsStatus
);

export const selectListOfOrderStatus = createSelector(
  selectMyOrderState,
  (myOrdersState: IMyOrderState) => myOrdersState?.listOfOrderStatus
);

export const selectEditOrder = createSelector(
  selectMyOrderState,
  selectSampleTypes,
  (myOrdersState: IMyOrderState, sampleTypes: ISampleType[]) => {
    if (myOrdersState?.editOrderDetails?.sample && isOrderWithSample(myOrdersState.editOrderDetails)) {
      return OrderUtils.getEditOrderInfo(myOrdersState.editOrderDetails, sampleTypes);
    }
    return null;
  }
);

export const selectOrderResultsPdfInfo = createSelector(selectMyOrderState, (myOrdersState: IMyOrderState) => {
  if (myOrdersState?.orderResultsPdfDetails) {
    return myOrdersState?.orderResultsPdfDetails;
  }
  return null;
});

export const selectDownloadOrderResultsStatus = createSelector(
  selectMyOrderState,
  (myOrdersState: IMyOrderState) => myOrdersState?.downloadOrderResultsStatus
);

export const selectEditOrderStatus = createSelector(
  selectMyOrderState,
  (myOrdersState: IMyOrderState) => myOrdersState.editOrderStatus
);
